import React, { FC, ReactElement, useEffect, useState } from "react";
import { Container, Toolbar, Box, useTheme, Typography, Tooltip } from "@mui/material";
// import { useProSidebar } from "react-pro-sidebar";
// import {
//   useSidebar,
//   useSidebarSelectedMenuTitleContext,
//   useTemplateThemeModeContext,
// } from "../../hooks";
// import { TemplateThemeModeContextType } from "../../context";
// import { useSelector } from "react-redux";
// import { RootState } from "../../redux/store/store";
// import { useLocation, useNavigate } from "react-router-dom";
// import { breadCrumbSwitchCase } from "../../services/breadCrumbSwitch";
import NavbarProfileMenu from "./NavbarProfileMenu";
import NavbarNotification from "./NavbarNotification";
import { useSelector } from "react-redux";
import { RootState } from "@redux/store/store";
import { Info } from "@mui/icons-material";

const Navbar: FC = (): ReactElement => {
  const user = useSelector((state: RootState) => state.auth.user);
  // const theme = useTheme()
  // const navigate = useNavigate();
  // const { broken } = useProSidebar();
  // const { toggle } = useSidebar();
  // const [breadcrumbLink, setBreadcrumbLinks] = React.useState([]) as any;
  // const location = useLocation();
  // const { menuTitle } = useSidebarSelectedMenuTitleContext();
  // const user = useSelector((state: RootState) => state.auth.user);
  // const { isDark } = useTemplateThemeModeContext() as TemplateThemeModeContextType;

  // useEffect(()=>{
  //  setBreadcrumbLinks(breadCrumbSwitchCase(location?.pathname))
  // },[location])


  const currencyFormatDetails = useSelector((state: RootState) => state.currencydateFormatDetails.currencydateFormatDetails);
  const isAdmin = currencyFormatDetails.isAdmin;
  const selectedCurrency = isAdmin
    ? currencyFormatDetails.adminCurrency
    : (currencyFormatDetails.userCurrency?.value !== 0 ? currencyFormatDetails.userCurrency : currencyFormatDetails.adminCurrency);
  return (
    <Container disableGutters maxWidth={false} sx={{ height: 48 }}>
      <Toolbar
        disableGutters
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          minHeight: "48px !important"
        }}
      >
        {/* <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
         {breadcrumbLink&&<RenderBreadcrumbs links={breadcrumbLink} />}
            {broken && (
            <IconButton
              onClick={toggle}
              sx={{
                color:isDark ? theme.palette.success.dark : theme.palette.success.light, 
                mt:"8px"}}
            >
              <Menu />
            </IconButton>)}
          </Box> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              py: 0,
              my: 0,
              gap: 2,
            }}
          >
            <NavbarNotification />
           
              <Typography component="div" sx={{ fontWeight: 600, fontFamily:'poppins' }}>
                <Typography component="div" sx={{ fontSize: '12px', lineHeight: 1 }}>
                  {user?.fullName.length <= 10 ? (
                    <span>{user?.fullName}</span>
                  ) : (
                    <Tooltip title={user?.fullName} placement={'top'}>
                      <span>{user?.fullName.slice(0, 10)}...<Info className="infoIcon" /></span>
                    </Tooltip>
                  )}
                </Typography>
                {selectedCurrency && selectedCurrency.label.trim() !== '' && (
                <Typography component='div' sx={{ lineHeight: 1.5, fontFamily:'poppins' }}>Currency - {selectedCurrency.label}</Typography>
              )}
              </Typography>
            <NavbarProfileMenu />
          </Box>
        </Box>
      </Toolbar>
    </Container>
  );
};

export default Navbar;
